import { render, staticRenderFns } from "./Realtime.vue?vue&type=template&id=1aaaffbe"
import script from "./Realtime.vue?vue&type=script&lang=js"
export * from "./Realtime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports